// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"592869c8","805":"9a7ddec0"}[chunkId] + ".chunk.css";
};